import { faqData } from '@/mocks/home';

export default function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3">常见问题</h2>
          <p className="text-foreground-600 text-sm md:text-base">你想知道的都在这里</p>
        </div>

        <div className="max-w-3xl mx-auto space-y-3">
          {faqData.map((faq) => (
            <div
              key={faq.id}
              className="rounded-xl bg-background-50 border border-background-200/70 overflow-hidden"
            >
              <div className="p-5 md:p-6">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-3 flex items-start gap-2">
                  <span className="text-primary-500 flex-shrink-0 mt-0.5">
                    <i className="ri-question-answer-line"></i>
                  </span>
                  {faq.question}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed pl-6">{faq.answer}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}